import React, { useRef, useState } from 'react';
import { dataForRvdUsersTable } from 'shared/helpers/utils';
import Breadcrumbs from 'shared/components/breadcrumbs/Breadcrumbs';
import CommonTable from 'features/tables/commonTable';
import { TCommonColumns } from 'shared/types/overtime.types';
import { Button } from 'antd';
import { DownloadOutlined, StopOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetRvdByIdQuery } from 'app/services/edpApiV1/rvd';
import { downloadExcell } from 'shared/helpers/excell/excell';
import { TRvdResponseData } from 'shared/types/rvd.types';
import BadgeData from '../rvdArchive/bageData/BadgeData';
import style from './index.module.scss';

const RvdArchiveInfo = () => {
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const { data } = useGetRvdByIdQuery({ id: id ? +id : 0 });
  const navigate = useNavigate();

  const downloadLink = useRef<HTMLAnchorElement>(null);

  const cancelLoad = () => {
    navigate('/rvd');
  };

  const download = () => {
    downloadExcell(data);
  };

  const breadCrumbs = [
    { name: 'Работа в выходной день', link: '/rvd' },
    { name: 'Информация', link: `/rvd/archive/${id}` },
  ];

  const columns: TCommonColumns = [
    {
      title: 'Дата работ',
      dataIndex: 'toDate',
      key: 'toDate',
    },
    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Табельный номер',
      dataIndex: 'personnelNumber',
      key: 'personnelNumber',
    },
    {
      title: 'Подразделение',
      dataIndex: 'division',
      key: 'division',
    },
    {
      title: 'Время работы',
      dataIndex: 'duration',
      key: 'duration',
    },
    {
      title: 'Способ компенсации',
      dataIndex: 'type',
      key: 'type',
    },
  ];

  return (
    <>
      <div className={style['top-side']}>
        <h3 className={style.title}>
          <Breadcrumbs breadCrumbs={breadCrumbs} />
        </h3>
        <div className={style.buttons}>
          <Button type="primary" onClick={download}>
            <DownloadOutlined /> Скачать
            <a href="#" ref={downloadLink} style={{ display: 'none' }}></a>
          </Button>
          <Button onClick={cancelLoad}>
            <StopOutlined /> Отмена
          </Button>
        </div>
      </div>
      <div className={style.statusData}>
        {data?.docNumber && (
          <p>
            <span>№ документа в 1С:</span>
            <span>{data?.docNumber}</span>
          </p>
        )}
        <p>
          <span>Статус документа:</span>
          <span>
            <BadgeData rvd={data as TRvdResponseData} />
          </span>
        </p>
      </div>
      <CommonTable
        dataSource={dataForRvdUsersTable(data?.employees ?? [])}
        columns={columns}
        currentPage={currentPage}
        currentSize={currentSize}
        setCurrentPage={setCurrentPage}
        setCurrentSize={setCurrentSize}
        total={data?.employees.length}
        selfPaginated={true}
      />
      {data?.userComment && (
        <div>
          <p>
            <span>Комментарий: </span>
            <span>{data?.userComment}</span>
          </p>
        </div>
      )}
    </>
  );
};

export default RvdArchiveInfo;
